import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const IsOrderedItem = ({ importedProductInfo, isImported, orderInfo }) => {
  const { t } = useTranslation();

  return (
    <div className="item-row">
      <div className="item-name">{`${orderInfo.product.title} ${orderInfo.product.status === 'deleted' ? t('stocks.ordersReceived.orderedItem.deleted') : ''}`}</div>
      <div className="item-current-q">{orderInfo.quantity}</div>
      <div className="item-q-ordered">
        {/* eslint-disable-next-line no-nested-ternary */}
        {isImported ? (importedProductInfo ? importedProductInfo.quantity_change : '-') : t('stocks.ordersReceived.orderedItem.scannedIn')}
      </div>
      <div className="item-q-received" />
      <div className="item-new-q" />
      <div className="empty" />
    </div>
  );
};

export default IsOrderedItem;
